/** @format */

import React from 'react';

import {
    SHAPE_CARTON_AUTOLOCK,
    SHAPE_CARTON_STRAIGHT_TUCK,
    SHAPE_CIRCLE,
    SHAPE_OVAL
} from 'frontier-constants';

import EllipseSvg from 'frontier/components/die_template/ellipse_svg';
import RectSvg from 'frontier/components/die_template/rectangle_svg';
import CartonSvg from 'frontier/components/die_template/carton_svg';

export default function ShapeSvg(props) {
    switch (props.shapeId) {
        case SHAPE_OVAL:
        case SHAPE_CIRCLE:
            return <EllipseSvg {...props} />;
        case SHAPE_CARTON_AUTOLOCK:
        case SHAPE_CARTON_STRAIGHT_TUCK:
            return <CartonSvg {...props} />;
    }
    return <RectSvg {...props} />;
}
